import { render, staticRenderFns } from "./customerform.vue?vue&type=template&id=4af98b0e&scoped=true&"
import script from "./customerform.vue?vue&type=script&lang=js&"
export * from "./customerform.vue?vue&type=script&lang=js&"
import style0 from "./customerform.vue?vue&type=style&index=0&id=4af98b0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af98b0e",
  null
  
)

export default component.exports